"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var abstract_measure_filter_dto_1 = require("./abstract-measure-filter-dto");
var filter_dto_builder_1 = require("../builder/filter-dto-builder");
/**
 * Range selection filter. Selects value sets which contains the value of the measure item holder in given range
 * exclusively. When any of {@link #valueFrom}, {@link #valueTo} is <CODE>null</CODE> the range is considered to be
 * open ended. The filter is not applied if both are <CODE>null</CODE>.
 *
 * Created by Hayk.Andriasyan on 5/24/2017.
 */
var MeasureRangeFilterDto = /** @class */ (function (_super) {
    __extends(MeasureRangeFilterDto, _super);
    function MeasureRangeFilterDto(filterType, onMeasureItemId, valueFrom, valueTo, inclusive, currencyId, byCategoryItemId) {
        var _this = _super.call(this, filter_dto_builder_1.FilterDtoBuilder.FILTER, filterType, onMeasureItemId, byCategoryItemId || null, currencyId || null) || this;
        _this.valueFrom = valueFrom;
        _this.valueTo = valueTo;
        _this.inclusive = inclusive;
        return _this;
    }
    return MeasureRangeFilterDto;
}(abstract_measure_filter_dto_1.AbstractMeasureFilterDto));
exports.MeasureRangeFilterDto = MeasureRangeFilterDto;
//# sourceMappingURL=measure-range-filter-dto.js.map